<template>
  <base-modal-bottom
    ref="PhoneModal"
    class="has-text-centered"
    :isFooter="true"
    :title="title"
  >
    <template #btn-close-icon>
      <div class="button-close-custom" @click="goToLegacyAdmin()">
        <base-icon
          style="margin: 0 auto"
          width="16"
          height="16"
          name="painel/close-icon"
        />
      </div>
    </template>

    <!-- Register phone -->
    <div class="c-modal-phone">
      <div class="margin-bottom">
        <base-icon width="88" height="95" :name="icon" />
      </div>

      <p class="margin-bottom c-modal-phone--max-width c-modal-phone--title">
        <strong>Queremos garantir maior segurança para o seu site!</strong>
      </p>

      <p class="margin-bottom c-modal-phone--max-width c-modal-phone--info">
        Enviaremos um código Token para confirmar a sua titularidade. Por favor,
        informe abaixo o número de celular em que você deseja receber o código
        de validação:
      </p>

      <div
        class="field-body column c-modal-phone--max-width c-modal-phone--max-width-input-phone"
      >
        <div class="field">
          <div class="control" autocomplete="off">
            <VuePhoneNumberInput
              v-model="phone"
              :required="true"
              :clearable="true"
              :translations="{
                countrySelectorLabel: 'Cod. País',
                countrySelectorError: 'Escolha um país',
                phoneNumberLabel: 'Insira seu celular',
                example: 'Exemplo :',
              }"
              :borderRadius="8"
              color="#5D758D"
              errorColor="#F65C6A"
              validColor="#3DAFB0"
              defaultCountryCode="BR"
              :preferredCountries="['BR']"
              size="lg"
              @update="resultsPhone = $event"
            />
          </div>
          <p class="control c-modal-phone__input-cod--error">
            {{ phoneError }}
          </p>
        </div>
      </div>


    </div>

    <template #footer>
      <div class="footer-modal-sms">
        <div class="c-modal-phone__btn-footer">
          <base-button-bottom
            :disabled="!resultsPhone.isValid || isNotValidNumber"
            @click.native="submit()"
            class="is-primary is-big c-modal-phone--max-width-btn footer-modal-sms"
            type="button"
          >
            Continuar
          </base-button-bottom>
        </div>
      </div>
    </template>
  </base-modal-bottom>
</template>

<script>
import BaseModalBottom from '@/components/BaseModalBottom.vue'
import BaseButtonBottom from '@/components/BaseButtonBottom.vue'
import VuePhoneNumberInput from 'vue-phone-number-input'

//import Wallet from '@/lib/api/Wallet'

const API_LEGACY_URL = process.env.VUE_APP_API_LEGACY_URL

export default {
  props: {
    title: {
      type: String,
      default: 'Validação de segurança',
    },
    icon: {
      type: String,
      default: 'account-shield',
    },
  },

  components: {
    BaseModalBottom,
    BaseButtonBottom,
    VuePhoneNumberInput,
  },

  computed: {
    logonToken() {
      return this.$store.state.app.logonToken
    },
  },

  data() {
    return {
      phone: null,
      phoneError: '',
      isNotValidNumber: false,
      resultsPhone: '',
    }
  },

  mounted() {
    this.open()
  },

  watch: {
    resultsPhone() {
      !this.resultsPhone.isValid &&
      this.phone &&
      this.phone > 12 &&
      this.resultsPhone.countryCode == 'BR'
        ? (this.phoneError = 'Verifique o número de telefone digitado!')
        : (this.phoneError = '')

      this.isValidNumber()
    },
  },

  methods: {
    isValidNumber() {
      if (
        this.phone &&
        this.resultsPhone.isValid &&
        this.resultsPhone.countryCode == 'BR'
      ) {
        var lenghtNumber = this.phone.replace(/[^\d]/g, '').split('').length
        lenghtNumber < 11 || lenghtNumber > 12
          ? ((this.isNotValidNumber = true),
            (this.phoneError =
              'Insira o DDD ou verifique o número de telefone digitado!'))
          : ((this.isNotValidNumber = false), (this.phoneError = ''))
      }
    },

    open() {
      this.$refs.PhoneModal.open()
    },

    submit() {
      const data = {
        phone: this.resultsPhone.formatInternational,
      }

      this.$emit('open-modal-verification', data)
    },

    goToLegacyAdmin() {
      if (this.logonToken) {
        window.location.href = `${API_LEGACY_URL}/${this.logonToken.token_payload.wed_id}#/admin`
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.c-base-modal__body {
  padding: 32px 16px 8px;
}

.footer-modal-sms {
  max-width: 450px !important;
  margin: 0 auto;
}

.c-modal-phone {
  &--max-width {
    max-width: 650px;
    margin: 0 auto;
    padding-bottom: 12px;
  }

  &--max-width-input-phone {
    max-width: 450px;
  }

  &--max-width-btn {
    width: 100% !important;
    max-width: 400px;
    position: relative;
    border-bottom-left-radius: 24px;
    border-bottom-right-radius: 24px;
    margin-bottom: 16px;
  }

  &--exemplo {
    font-size: 12px;
  }

  &--title {
    font-size: 16px;
    margin-bottom: 12px;
    padding: 0;
  }

  &--info {
    font-size: 16px;
    text-align: center;
    max-width: 440px;
    span {
      color: $primary;
      font-weight: bold;
    }
  }

  &__input-cod {
    &--error {
      color: red;
      margin-top: 10px;
      font-size: 14px;
      text-align: center;
    }
  }

  &__btn-footer {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
}

.field-body {
  margin-top: 20px;
}

.button-close-custom {
  width: 40px;
}

</style>
